<template>
  <PageContentLayoutOnly headerColor="#fafafa">
    <div>
      <div v-if="showSelectedAudience === false" class="pb-3">
        <button
          @click.prevent="processHomeowners(true)"
          :disabled="hasReadonly || isReadOnly"
          class="button is-primary is-rounded"
        >
          Save
        </button>
      </div>
      <div scheduling class="notification headerColor" v-if="formData">
        <div class="box is-12">
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <transition name="fade" mode="out-in" appear>
              <form @submit.prevent="handleSubmit(processHomeowners)" class="form">
                <fieldset>
                  <div class="force-center subtitle pb-5 pt-5">
                    Would you like to send your message to all homeowners?
                  </div>
                  <div class="columns">
                    <div class="column is-12">
                      <b-field label="Send to All Recipients">
                        <b-select
                          v-model="formData.audienceType"
                          required="true"
                          :disabled="hasReadonly || isReadOnly"
                          placeholder="Select a Target Audience"
                          @input="processAudienceType(true)"
                        >
                          <option
                            v-for="option in audienceTypeList"
                            :value="option.value"
                            :key="option.value"
                          >
                            {{ option.label }}
                          </option>
                        </b-select>
                      </b-field>
                    </div>
                  </div>
                  <div v-if="showSelectedAudience === true" class="force-center subtitle pb-5">
                    <div class="pb-5">
                      <span class="force-center subtitle"
                        >Search for homeowners to target for this communication</span
                      >
                    </div>
                    <div class="pb-5 pt-5 force-left columns">
                      <b-field class="pl-5" label="Owner">
                        <span class="column is-12"
                          ><b-autocomplete
                            vr-owner-select
                            v-model="query"
                            :data="data"
                            :loading="isFiltering"
                            :open-on-focus="true"
                            :keep-first="true"
                            :disabled="hasReadonly || isReadOnly"
                            field="label"
                            icon="magnify"
                            placeholder="e.g. First Name or Last Name or Address"
                            @typing="filterList"
                            @select="optionSelected"
                          >
                            <template #empty>No results found</template>
                          </b-autocomplete>
                        </span>
                        <span class="column is-1">
                          <b-button
                            v-on:keyup.enter="addHomeowner"
                            :disabled="hasReadonly || isReadOnly"
                            type="is-primary is-small"
                            @click.prevent="addHomeowner"
                            >Add Homeowner</b-button
                          ></span
                        >
                      </b-field>
                    </div>
                    <div class="column is-12 pl-3">
                      <label class="label">Selected Homeowners</label>
                      <div>
                        <div
                          :style="
                            `
                display: inline;
                `
                          "
                          class="columns"
                        >
                          <div
                            v-if="
                              recipientsSelected !== undefined &&
                                recipientsSelected &&
                                recipientsSelected.length === 0
                            "
                          >
                            <span style="font-style:italic">No homeowners added</span>
                          </div>
                          <div
                            class="pt-3"
                            v-for="(recipient, index) in recipientsSelected"
                            :key="index"
                            :style="{
                              verticalAlign: 'top',
                              marginLeft: '0px'
                            }"
                          >
                            <b-taglist attached v-if="index % 2 === 0">
                              <b-tag
                                type="is-light"
                                style="background-color: white !important;"
                                closable
                                @close="eraseRecipient({ recipient })"
                                >{{ JSON.stringify(recipient) }}</b-tag
                              >
                              <b-tag
                                v-if="recipientsSelected[index + 1]"
                                type="is-light"
                                style="background-color: white !important;"
                                closable
                                @close="eraseRecipient2(recipientsSelected[index + 1])"
                                >{{ JSON.stringify(recipientsSelected[index + 1]) }}</b-tag
                              >
                            </b-taglist>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <ValidationProvider vid="providerErrors" v-slot="{ errors }">
                    <div class="field">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </fieldset>
              </form>
            </transition>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </PageContentLayoutOnly>
</template>

<script>
import _get from 'lodash/get'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapState, mapGetters } from 'vuex'
import { data } from './keys/data'
import { methods } from './keys/methods'
import { getOwnersList } from '@/services/Roster/Unit/sequences/getOwnersList'

export default {
  name: 'TargetAudienceCommunication',
  components: {
    ValidationObserver,
    ValidationProvider,
    PageContentLayoutOnly
  },

  data,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId,
      ...mapGetters('user', ['authUser']),
      ...mapGetters('communication', [
        'supportMailDelivery',
        'supportEmailDelivery',
        'supportSMSDelivery',
        'isLegalCommunication',
        'mailingTypeID',
        'mailingType',
        'mailMessage',
        'emailMessage',
        'emailMessageSubject',
        'mailingCommunicationID',
        'selectedDeliveryOwnerIDs',
        'selectedDeliveryOwners',
        'communicationDescription',
        'isColor',
        'isFullDuplex',
        'deliveryDate',
        'hasReadonly'
      ])
    })
  },

  async mounted() {
    this.loading = true

    this.reload()

    const hoaID = _get(this, ['$store', 'getters', 'user/hoaIDInteger'], null)

    const { list } = await getOwnersList({
      hoaID
    })

    console.debug('selectedDeliveryOwnerIDs=' + this.selectedDeliveryOwnerIDs)
    console.debug('selectedDeliveryOwners=' + this.selectedDeliveryOwners)

    this.data = list
    this.fullList = list

    console.debug('fullList=' + JSON.stringify(this.fullList))

    this.ownerIdsSelected = this.selectedDeliveryOwnerIDs

    if (
      this.ownerIdsSelected !== undefined &&
      this.ownerIdsSelected &&
      this.selectedDeliveryOwners !== undefined &&
      this.selectedDeliveryOwners === 'selected-owners'
    ) {
      this.showSelectedAudience = true
      this.formData.audienceType = 'No'
    } else {
      console.debug('all-owners')
      this.showSelectedAudience = false
      this.formData.audienceType = 'Yes'
    }

    if (this.fullList && this.ownerIdsSelected && this.ownerIdsSelected.length > 0) {
      Array.from(this.ownerIdsSelected).forEach(ownerID => {
        if (ownerID) {
          const tempOwner = this.fullList.filter(owner => {
            try {
              if (owner.value === ownerID) {
                return owner.label
              }
            } catch (x) {
              console.error(x)
            }
          })

          if (
            this.recipientsSelected !== undefined &&
            this.recipientsSelected &&
            tempOwner[0] !== undefined &&
            tempOwner[0] &&
            tempOwner[0].label
          ) {
            this.recipientsSelected.push(tempOwner[0].label)
          }
        }
      })

      if (
        this.recipientsSelected !== undefined &&
        this.recipientsSelected &&
        this.recipientsSelected.length > 0
      ) {
        this.$store
          .dispatch('communication/saveDeliveryOwners', {
            selectedDeliveryOwners: this.recipientsSelected
          })
          .then(() => {
            this.$store.dispatch('communication/saveDeliveryOwnerIDs', {
              selectedDeliveryOwnerIDs: this.ownerIdsSelected
            })
          })
      }
    }

    this.loading = false
  },

  watch: {
    hoaId() {
      this.reload()
    }
  },

  methods,

  i18n: {
    messages: {
      en: {
        workOrderUpdate: { title: 'Target Audiences' }
      }
    }
  }
}
</script>

<style lang="scss">
#update-work-order .my-grid-class {
  height: 400px;
}

#update-work-order tbody {
  min-height: 100px !important;
  overflow: auto !important;
}
</style>
